import { render } from "./IconRegistered.vue?vue&type=template&id=4b38c9ea"
import script from "./IconRegistered.vue?vue&type=script&lang=js"
export * from "./IconRegistered.vue?vue&type=script&lang=js"
script.render = render

export default script